'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const {
  app
} = window;
class UpdateCompanyForm extends _react.Component {
  state = {
    status_messages: {}
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompany();
    component.fetchfetchProfessionalDomain();
  }
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-mine').then(function (xhr, response) {
      let company_monitoring = (response.company?.monitoring || []).map(function (data, i) {
        let file_parsed = (data.file || []).map(function (file) {
          let descriptor = {
            ...file,
            status: 'uploaded',
            filename: file.url.slice(file.url.lastIndexOf('/') + 1),
            pdf: true
          };
          return descriptor;
        });
        let monitoring = {
          ...data,
          file: file_parsed
        };
        component.setState({
          ['__files-company[monitoring][' + monitoring.id + '][file]']: file_parsed
        });
        return monitoring;
      });
      delete response.company?.monitoring;
      const logo = (response.company?.logo || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1)
        };
        return descriptor;
      });
      delete response.company.logo;
      const customer_proposal_pdf = (response.company?.integration_collaborator?.customer_proposal_pdf || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.company?.integration_collaborator?.customer_proposal_pdf;
      const customer_proposal_accepted_pdf = (response.company?.integration_collaborator?.customer_proposal_accepted_pdf || []).map(function (data) {
        let descriptor = {
          ...data,
          status: 'uploaded',
          filename: data?.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      delete response.company?.integration_collaborator?.customer_proposal_accepted_pdf;
      const account_status = response.company?.account_status;
      delete response.company.account_status;
      const update = (0, _getStateFromObject.default)({
        data: response.company,
        model: 'company'
      });
      component.setState({
        ...update,
        'company[monitoring]': company_monitoring,
        'company[account_status]': account_status,
        'company[logo]': logo,
        ['__files-company[logo]']: logo,
        'company[integration_collaborator][customer_proposal_pdf]': customer_proposal_pdf,
        ['__files-company[integration_collaborator][customer_proposal_pdf]']: customer_proposal_pdf,
        'company[integration_collaborator][customer_proposal_accepted_pdf]': customer_proposal_accepted_pdf,
        ['__files-company[integration_collaborator][customer_proposal_accepted_pdf]']: customer_proposal_accepted_pdf,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchfetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const company = (0, _getFormData.default)({
      state: state,
      pattern: 'company['
    });
    qwest.post('/company/update-mine', company).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo('/mon-compte-entreprise');
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/company/update"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium "
    }, "Coordonn\xE9es de la personne en charge du recrutement"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[lastname]'],
      name: "company[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[firstname]'],
      name: "company[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[profession]'],
      name: "company[profession]",
      type: "text",
      label: "Fonction dans l'entreprise",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[home_phone_number]'],
      name: "company[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[phone_number]'],
      name: "company[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[login]'],
      name: "company[login]",
      type: "text",
      label: "Adresse mail (login)",
      status: state.status_messages
    }))), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      size: "large",
      className: "u-margin-right-10",
      href: "/mon-compte-entreprise",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Annuler"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, "Valider les modifications", loader)));
    return output;
  }
}
exports.default = UpdateCompanyForm;
